import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import React from 'react'
import IntlProviderWrapper from './intlProviderWrapper'
import { LocaleProvider } from './localeContext'
import { PaymentStepProvider } from './paymentStepContext'
import { UserEmailProvider } from './userEmailContext'

const AppProviders = (props: React.PropsWithChildren) => {
  const queryClient = new QueryClient()
  return (
    <LocaleProvider>
      <IntlProviderWrapper>
        <PaymentStepProvider>
          <UserEmailProvider>
            <QueryClientProvider client={queryClient}>
              {props.children}
            </QueryClientProvider>
          </UserEmailProvider>
        </PaymentStepProvider>
      </IntlProviderWrapper>
    </LocaleProvider>
  )
}

export default AppProviders
